import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { OfferBar } from '../components/OfferBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { DoloresSection } from '../components/DoloresSection';
import { ProductShowcase } from '../components/ProductShowcase';
import { BeneficiosSection } from '../components/BeneficiosSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ProductEmbed } from '../components/ProductEmbed';
import { BonosSection } from '../components/BonosSection';
import { FAQ } from '../components/FAQ';
import { FooterCTA } from '../components/FooterCTA';
import { UrgencyTimer } from '../components/UrgencyTimer';
export function EnfocadoLanding() {
  const timelineRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: timelineRef,
    offset: ['start center', 'end center']
  });
  return <div className="min-h-screen bg-[#0A0A0A] text-white font-sans selection:bg-[#FF6B35] selection:text-black" data-id="element-280">
      <OfferBar data-id="element-281" />
      <Header data-id="element-282" />
      <main data-id="element-283">
        <Hero data-id="element-284" />

        {/* Timeline Container Wrapper */}
        <div className="relative" ref={timelineRef} data-id="element-285">
          {/* Mobile Progress Line */}
          <div className="md:hidden absolute left-4 top-[100px] bottom-[100px] w-1 bg-gray-800 rounded-full z-30" data-id="element-286">
            <motion.div className="w-full bg-[#FF6B35] rounded-full shadow-[0_0_10px_#FF6B35]" style={{
            height: useTransform(scrollYProgress, [0, 1], ['0%', '100%'])
          }} data-id="element-287" />
          </div>

          <DoloresSection data-id="element-288" />
          <ProductShowcase data-id="element-289" />
          <BeneficiosSection data-id="element-290" />
        </div>

        <ProductEmbed data-id="element-291" />
        <UrgencyTimer data-id="element-292" />
        <BonosSection data-id="element-293" />
        <TestimonialsSection data-id="element-294" />
        <FAQ data-id="element-295" />
      </main>
      <FooterCTA data-id="element-296" />
    </div>;
}